var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH2ChooseIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.9993V11.9993H3C1.347 11.9993 0 13.3463 0 14.9993V20.9993H21.633C21.216 19.1663 21 17.1923 21 14.9993Z",
    fill: "#564DCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.877 26.9993C45.831 30.1523 42.711 32.8343 38.241 35.4023C37.554 35.7953 36.78 35.9993 36 35.9993C35.22 35.9993 34.446 35.7953 33.768 35.4083C29.298 32.8343 26.178 30.1493 24.129 26.9993H0V41.9993C0 43.6553 1.347 44.9993 3 44.9993H45C46.656 44.9993 48 43.6553 48 41.9993V26.9993H47.877ZM13.5 35.9993H7.5C6.672 35.9993 6 35.3273 6 34.4993C6 33.6713 6.672 32.9993 7.5 32.9993H13.5C14.328 32.9993 15 33.6713 15 34.4993C15 35.3273 14.328 35.9993 13.5 35.9993Z",
    fill: "#564DCA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.091 7.62223L36.591 3.12223C36.21 2.96023 35.787 2.96023 35.406 3.12223L24.906 7.62223C24.357 7.85623 24 8.39923 24 8.99923V14.9992C24 23.2522 27.051 28.0762 35.253 32.8012C35.484 32.9332 35.742 32.9992 36 32.9992C36.258 32.9992 36.516 32.9332 36.747 32.8012C44.949 28.0882 48 23.2642 48 14.9992V8.99923C48 8.39923 47.643 7.85623 47.091 7.62223ZM41.673 14.4382L35.673 21.9382C35.385 22.2922 34.953 22.4992 34.5 22.4992C34.479 22.4992 34.455 22.4992 34.437 22.4992C33.96 22.4782 33.519 22.2322 33.252 21.8332L30.252 17.3332C29.793 16.6432 29.979 15.7132 30.669 15.2542C31.353 14.7982 32.286 14.9782 32.748 15.6712L34.611 18.4642L39.327 12.5662C39.846 11.9212 40.791 11.8192 41.436 12.3322C42.084 12.8452 42.186 13.7902 41.673 14.4382Z",
    fill: "#00C4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH2ChooseIcon01);
export default __webpack_public_path__ + "static/media/h2_choose_icon01.de6545753af121d0364779058dfa5a1b.svg";
export { ForwardRef as ReactComponent };